export const initialTrailInteractionState = {
  selectedTrailId: null,
  hoveredTrailId: null,
  focusRequest: 0,
};

export const filterDestinationTrails = (trails = [], difficulty = [], styles = []) => trails.filter(
  (trail) => (difficulty.length === 0 || difficulty.includes(trail.difficulty))
    && (styles.length === 0 || styles.includes(trail.riding_style)),
);

export const trailInteractionReducer = (state, action) => {
  switch (action.type) {
    case "select":
      return {
        ...state,
        selectedTrailId: action.trailId ?? null,
        focusRequest: state.focusRequest + 1,
      };
    case "hover":
      return { ...state, hoveredTrailId: action.trailId ?? null };
    case "reconcile": {
      const visibleIds = new Set(action.visibleTrailIds ?? []);
      return {
        ...state,
        selectedTrailId: state.selectedTrailId && visibleIds.has(state.selectedTrailId)
          ? state.selectedTrailId
          : null,
        hoveredTrailId: state.hoveredTrailId && visibleIds.has(state.hoveredTrailId)
          ? state.hoveredTrailId
          : null,
      };
    }
    default:
      return state;
  }
};
